import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  GbegvtauftraganmeldungService,
  GbgrundbuchgeschaeftService,
  GrundbuchgeschaeftRestDetailEntryMeta,
  GrundbuchmeldungBearbeitetstatusResponseMeta
} from '../../../../core/gb-api';
import { FormatConfigService } from '../../../../core/services/format-config.service';
import { AvgeometergeschaeftService, AvReferenzNummerListEntry, GeometergeschaeftListEntryMeta } from '../../../../core/av-api';
import { ErweiterungConfigResponse } from '../../../../core/base-api';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { AppPermissionService } from '../../../../core/services/app-permission.service';
import { AbstractComponent } from '../../../../shared/components/abstract-component/abstract.component';
import { ListLoader } from '../../../../shared/components/list-loader/list-loader';
import { ListLoaderPaginationBuilder } from '../../../../shared/components/list-loader/list-loader-pagination';
import { map } from 'rxjs/operators';
import { PaginationLookupResult } from '../../../../shared/components/list-loader/pagination-lookup-result';
import { Observable } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';
import { KopfdatenelementComponent } from '../../../../shared/widgets/kopfdatenelement/kopfdatenelement.component';
import { KompaktGrundbuchgeschaeftComponent } from '../../../../shared/kompaktdarstellung/grundbuchgeschaeft/kompakt-grundbuchgeschaeft.component';
import { StammpersonTableComponent } from '../../../../shared/widgets/person/stammperson-table/stammperson-table.component';
import { BeschreibungTableWrapperComponent } from '../../../../shared/components/table/beschreibung-table-wrapper.component';
import { GeogeschaeftTableComponent } from '../../../../shared/widgets/geogeschaeft-table/geogeschaeft-table.component';
import { CapSpinnerSmallComponent } from '../../../../shared/components/cap-spinner-small/cap-spinner-small.component';
import { AsyncPipe } from '@angular/common';
import { DatumPipe } from '../../../../shared/pipes/simple/datum.pipe';
import { DatumZeitPipe } from '../../../../shared/pipes/simple/datumZeit.pipe';
import { FormatAvReferenzNummernPipe } from '../../../../shared/pipes/format/format-av-referenz-nummern.pipe';
import { KompaktBenutzerPipe } from '../../../../shared/kompaktdarstellung/benutzer/kompakt-benutzer-pipe';
import { TranslateNamePipe } from '../../../../shared/pipes/simple/translate-name.pipe';
import ActiveErweiterungenEnum = ErweiterungConfigResponse.ActiveErweiterungenEnum;

@Component({
  selector: 'cap-details-grundbuchgeschaeft',
  templateUrl: './details-grundbuchgeschaeft.component.html',
  styleUrls: ['./details-grundbuchgeschaeft.component.scss'],
  imports: [
    KopfdatenelementComponent,
    KompaktGrundbuchgeschaeftComponent,
    TranslatePipe,
    StammpersonTableComponent,
    BeschreibungTableWrapperComponent,
    GeogeschaeftTableComponent,
    CapSpinnerSmallComponent,
    AsyncPipe,
    DatumPipe,
    DatumZeitPipe,
    FormatAvReferenzNummernPipe,
    KompaktBenutzerPipe,
    TranslateNamePipe
  ]
})
export class DetailsGrundbuchgeschaeftComponent extends AbstractComponent implements OnInit, OnDestroy {
  bearbeitetstatus: GrundbuchmeldungBearbeitetstatusResponseMeta;
  bearbeitenButtondisabled = false;
  showBearbeitetstatus = true;
  hasPermissionStatusBearbeiten;
  geoGeschaeftLoader: ListLoader<GeometergeschaeftListEntryMeta>;
  eGVAnmeldung = '';
  isAvplus = false;

  isShowAvReferenzNummern = false;
  avReferenzNrs$: Observable<AvReferenzNummerListEntry[]>;

  private _geschaeft: GrundbuchgeschaeftRestDetailEntryMeta;
  private readonly PAGE_SIZE = 15;
  private readonly CURRENT_PAGE = 1;

  constructor(
    private egvtAuftragService: GbegvtauftraganmeldungService,
    protected appformatConfigService: FormatConfigService,
    private geometerGeschaeftService: AvgeometergeschaeftService,
    private grundbuchgeschaeftService: GbgrundbuchgeschaeftService,
    private permissionService: AppPermissionService
  ) {
    super();
    keysToTranslate<string>([
      'Abschluss (Rechtsgültigsetzung)',
      'Tagebuchstatus',
      'MeldungBearbeitet',
      'durch',
      'MarkiereAlsBearbeitet',
      'MarkiereAlsNichtBearbeitet'
    ]);
  }

  ngOnInit() {
    this.checkPermissionStatusBearbeiten();
    this.addSub(
      this.appformatConfigService.settingsConfig$.subscribe((config) => {
        this.isShowAvReferenzNummern = config?.isUseAvReferenceNumbers;
      })
    );
    this.addSub(
      this.appformatConfigService.erweiterungsConfig$.subscribe((config) => {
        this.isAvplus = config?.activeErweiterungen.includes(ActiveErweiterungenEnum.AV_PLUS);
      })
    );
  }

  @Input()
  set geschaeft(value: GrundbuchgeschaeftRestDetailEntryMeta) {
    if (!value) {
      return;
    }
    this._geschaeft = value;
    this.update();
  }

  get geschaeft(): GrundbuchgeschaeftRestDetailEntryMeta {
    return this._geschaeft;
  }

  update() {
    this.egvtAuftragService.loadEgvtAuftragListEntryById(this._geschaeft.id.id).subscribe({
      next: (a) => {
        this.eGVAnmeldung = a ? a.anmeldungsId : '';
      },
      error: (err) => {
        if (err.status === 404) {
          return;
        }
      }
    });
    this.avReferenzNrs$ = this.geometerGeschaeftService.loadAvReferenzNummerBy(this.geschaeft.id.id).pipe(map((a) => a.results));
    this.geoGeschaeftLoader = this.createGeoGeschaeftByGrundstueckIdLoader();
    const sub = this.grundbuchgeschaeftService.getGbGeschaeftBearbeitetstatus(this._geschaeft.id.id).subscribe({
      next: (status) => {
        this.bearbeitetstatus = status;
        this.showBearbeitetstatus = true;
      },
      error: (err) => {
        if (err.status === 404) {
          this.showBearbeitetstatus = false;
        }
        this.bearbeitenButtondisabled = false;
      }
    });
    this.subscriptions.push(sub);
  }

  updateBearbeitetStatus() {
    this.bearbeitenButtondisabled = true;
    const sub = this.grundbuchgeschaeftService
      .setGbGeschaeftBearbeitetstatus(this._geschaeft.id.id, !this.bearbeitetstatus.isBearbeitet)
      .subscribe({
        next: () => {
          const subBearbeiten = this.grundbuchgeschaeftService.getGbGeschaeftBearbeitetstatus(this._geschaeft.id.id).subscribe((state) => {
            this.bearbeitetstatus = state;
            this.bearbeitenButtondisabled = false;
          });
          this.subscriptions.push(subBearbeiten);
        },
        error: () => {
          this.bearbeitenButtondisabled = false;
        }
      });
    this.subscriptions.push(sub);
  }

  checkPermissionStatusBearbeiten() {
    this.hasPermissionStatusBearbeiten = this.permissionService.hasPermission('GBMELDUNGENBEARBEITETSTATUS');
  }

  private createGeoGeschaeftByGrundstueckIdLoader(): ListLoader<GeometergeschaeftListEntryMeta> {
    const observable = (offset: number, limit: number) =>
      this.geometerGeschaeftService.loadGeometergeschaeftSichtGbMeldung(this._geschaeft.id.id, offset, limit).pipe(
        map(
          (r) =>
            <PaginationLookupResult<GeometergeschaeftListEntryMeta>>{
              result: r.results,
              totalItems: 0
            }
        )
      );

    const loader = ListLoaderPaginationBuilder.builder<GeometergeschaeftListEntryMeta>()
      .setLookupItemFunc(observable)
      .setCurrentPage(this.CURRENT_PAGE)
      .setPageSize(this.PAGE_SIZE)
      .build();
    this.addLoader(loader);
    return loader;
  }
}
